import { render, staticRenderFns } from "./second.page.vue?vue&type=template&id=e780143c"
import script from "./second.page.vue?vue&type=script&lang=js"
export * from "./second.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports